import React from "react";
import {
  Download,
  FileImage,
  FileText,
  Film,
  Folder,
  HardDrive,
  Image as ImageIcon,
  Link2,
  Monitor,
  Music,
  Trash2,
} from "lucide-react";

/** Shared file-type iconography for Explorer, the desktop and Start. */

const SPECIAL = {
  desktop: { icon: Monitor, tone: "#4a90d9" },
  documents: { icon: FileText, tone: "#e8a33d" },
  downloads: { icon: Download, tone: "#3fa34d" },
  music: { icon: Music, tone: "#c4451c" },
  pictures: { icon: ImageIcon, tone: "#8661c5" },
  videos: { icon: Film, tone: "#0f7b6c" },
};

const BY_EXT = {
  txt: { icon: FileText, tone: "#6b7280" },
  pdf: { icon: FileText, tone: "#c4451c" },
  url: { icon: Link2, tone: "#0a84ff" },
  png: { icon: FileImage, tone: "#8661c5" },
};

export function visualFor(node) {
  if (!node) return { icon: FileText, tone: "#6b7280" };
  if (node.type === "drive") return { icon: HardDrive, tone: "#5b6b7d" };
  if (node.type === "recycle") return { icon: Trash2, tone: "#6b7280" };
  if (node.special) return SPECIAL[node.special];
  if (node.type === "folder" || node.type === "root")
    return { icon: Folder, tone: "#e8a33d" };
  return BY_EXT[node.ext] || { icon: FileText, tone: "#6b7280" };
}

export function NodeIcon({ node, size = 20 }) {
  const { icon: Icon, tone } = visualFor(node);
  const isFolder =
    node.type === "folder" || node.type === "drive" || node.type === "root";
  return (
    <Icon
      size={size}
      style={{ color: tone }}
      fill={isFolder ? tone : "none"}
      fillOpacity={isFolder ? 0.22 : 0}
    />
  );
}
